import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { useCallback } from 'react';
import { gql } from '@/__generated__';

const SetListStreamTargets = gql(`
  mutation SetListStreamTargets($id: ID!, $input: SetStreamCustomTargetsInput!) {
    setStreamCustomTargets(id: $id, input: $input)
  }
`);

/** Staged until the list is saved, so Cancel really cancels. */
export const useCommitStreamTargets = () => {
  const toast = useToast();
  const [setCustomTargets] = useMutation(SetListStreamTargets, {
    update: (cache, { data }, { variables }) => {
      if (!data?.setStreamCustomTargets || !variables) return;
      cache.modify({
        id: cache.identify({ id: variables.id, __typename: 'Stream' }),
        fields: { customTargets: () => data.setStreamCustomTargets },
      });
    },
  });

  return useCallback(
    async (id: string, customTargets: string[]) => {
      try {
        await setCustomTargets({ variables: { id, input: { customTargets } } });
        return true;
      } catch (error) {
        toast.error({
          title: 'Could not save the stream targets',
          subTitle: error instanceof Error ? error.message : undefined,
        });
        return false;
      }
    },
    [setCustomTargets, toast],
  );
};
